import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, Col, Row, ModalBody, Modal } from 'reactstrap';
import './index.css';
import Storage from '../../services/Storage';
import closeImg from '../../assets/img/close.png';
import DateService from '../../services/DateService';
import { CommonButton } from '../CommonComponents';
import UploadDocPreview from '../CustomModal/UploadDocPreview/UploadDocPreview';
import { Roles } from '../../constants/Roles';

const OtherOwners = ({
  isMultipleUser,
  previewData,
  handleOwner,
  selectedOwnerState,
  selectedOwnerDistrict,
  selectedOwnerCity,
  userId,
  activeOwner,
}) => {
  const [modal, setModal] = useState(false);
  const [popupImgPreview, setPopupImgPreview] = useState('');
  const [title, setTitle] = useState('');

  const navigate = useNavigate();
  const location = useLocation();
  let userInfo = Storage.getUserInfoDetail();
  let roleId = userInfo ? userInfo.id : null;
  let roleName = userInfo ? userInfo.role : '';

  const setBreadcrumbsRecord = () => {
    if (previewData.business_name) {
      Storage.setBreadcrumbsrRecord([
        {
          title: 'Preview App',
          url: location.pathname,
        },
        {
          title: previewData.business_name,
          url: `/pages/new-dealer/${previewData.id}`,
        },
      ]);
    }
  };

  const toggle = (val, title, key) => {
    if (key) {
      setPopupImgPreview(val);
      setTitle(title);
    }
    setModal(!modal);
  };

  return (
    <div>
      {(isMultipleUser || activeOwner === false) &&
        previewData.owners &&
        previewData.owners.map((val, index) => {
          return (
            <div key={index} id='otherOwner'>
              <Row>
                <Col lg={10}>
                  <div className='main-title'>
                    {val.is_primary_contact
                      ? 'Owners Information'
                      : 'Other Owners Information'}
                    {roleName &&
                      (roleName === Roles.TM_NAME ||
                        roleName === Roles.BH_NAME ||
                        (roleName === Roles.SH_NAME &&
                          previewData.created_by &&
                          previewData.created_by === roleId)) ? (
                      <i
                        onClick={() => {
                          setBreadcrumbsRecord();
                          navigate(
                            `/pages/add-owner/${Storage.getAddNewDealerId() ? Storage.getAddNewDealerId() : userId
                            }`
                          );
                        }}
                        className='fa fa-edit editButton noprint'
                      ></i>
                    ) : (
                      ''
                    )}
                  </div>
                  {val.is_primary_contact && (
                    <div className='common-title subTitle'>Active Owner</div>
                  )}
                  <div className='ownerdatablock'>
                    <div className='info'>
                      <div className='common-heading'>Owner's Name</div>
                      <div className='subData'>{val.name}</div>
                    </div>
                    <div className='ownerdatablock'>
                      <div className='info'>
                        <div className='common-heading'>Designation</div>
                        <div className='subData'>{val.designation}</div>
                      </div>
                    </div>
                    <div className='info'>
                      <div className='common-heading'>Mobile No</div>
                      <div className='subData'>{val.mobile_number}</div>
                    </div>
                    <div className='info'>
                      <div className='common-heading'>Whatsapp No</div>
                      <div className='subData'>
                        {val.whatsapp_mobile_number}
                      </div>
                    </div>
                    <div className='info'>
                      <div className='common-heading'>Email</div>
                      <div className='subData'>{val.email}</div>
                    </div>
                    <div className='info'>
                      <div className='common-heading'>Marital Status</div>
                      <div className='subData'>{val.marital_status}</div>
                    </div>
                    {val.birth_date ? (
                      <div className='info'>
                        <div className='common-heading'>Birth Date</div>
                        <div className='subData'>
                          <i
                            style={{ color: '#545CD8' }}
                            className='fa fa-calendar mr-1 noprint'
                          ></i>
                          {DateService.localDateOnly(val.birth_date) || 'N/A'}
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                    {val.wedding_date ? (
                      <div className='info'>
                        <div className='common-heading'>Marriage 'A Date</div>
                        <div className='subData'>
                          <i
                            style={{ color: '#545CD8' }}
                            className='fa fa-calendar mr-1 noprint'
                          ></i>
                          {DateService.localDateOnly(val.wedding_date) || 'N/A'}
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                    <div className='info'>
                      <div className='common-heading'>Pincode</div>
                      <div className='subData'>{val.pincode}</div>
                    </div>
                    {selectedOwnerState.length > 0 &&
                      selectedOwnerState.map((val, index) => {
                        return (
                          <div className='info' key={index}>
                            <div className='common-heading'>State</div>
                            <div className='subData'>{val.state_name}</div>
                          </div>
                        );
                      })}
                    {selectedOwnerDistrict.length > 0 &&
                      selectedOwnerDistrict.map((val, index) => {
                        return (
                          <div className='info' key={index}>
                            <div className='common-heading'>District</div>
                            <div className='subData'>{val.district_name}</div>
                          </div>
                        );
                      })}
                    {selectedOwnerCity.length > 0 &&
                      selectedOwnerCity.map((val, index) => {
                        return (
                          <div className='info' key={index}>
                            <div className='common-heading'>City/Town</div>
                            <div className='subData'>
                              {val.city_or_town_name}
                            </div>
                          </div>
                        );
                      })}
                    <div className='info'>
                      <div className='common-heading'>Residential Address</div>
                      <div className='subData'>{val.address}</div>
                    </div>
                  </div>
                </Col>
                <Col lg={1}></Col>
                <Col lg={1}>
                  <div
                    className='d-flex justify-content-lg-end ownerImg'
                    onClick={() => {
                      if (val.image.includes('.pdf')) {
                        window.open(val.image, '_blank');
                      } else {
                        toggle(val.image, 'Owner Image', 1)
                      }
                    }
                    }
                  >
                    <img src={val.image} width={'100px'} alt='OwnerImg' />
                  </div>
                </Col>
                {val.is_primary_contact === true && (
                  <Col xs={12}>
                    {previewData.owners.length > 1 && (
                      <div className='text-right'>
                        {/* <Button
                          onClick={(e) =>
                            handleOwner(e, val.is_primary_contact)
                          }
                          className='next-button moreOwnerBtn noprint'
                        >
                          View Other Owners Information
                        </Button> */}
                        <CommonButton name={'View Other Owners Information'} btnClass={'btnTernary'} maxWidth='230px' type="button" onClick={(e) =>
                          handleOwner(e, val.is_primary_contact)
                        } />
                      </div>
                    )}{' '}
                  </Col>
                )}
              </Row>
            </div>
          );
        })}

      {/* Preview Doc Modal */}
      <Modal
        id='previewAppImgModal'
        isOpen={modal}
        toggle={toggle}
        className='uploadDocModal'
        centered
      >
        <ModalBody className='pl-0 pr-0'>
          <Container>
            <Row>
              <Col xs={12}>
                <div className='modalHeading'>
                  <div className='title leftTitle'>{title}</div>
                  <div className='closeButton'>
                    <img
                      src={closeImg}
                      alt='close'
                      onClick={() => setModal(!modal)}
                    />
                  </div>
                </div>
              </Col>
              <Col xs={12} className='text-center'>
                <UploadDocPreview
                  isRemove={false}
                  uploadDocpath={popupImgPreview}
                // handleRemoveClick={() => removeSelectedImage(imageKey)}
                />
                {/* {popupImgPreview &&
                  popupImgPreview.split('.').pop() == 'pdf' ? (
                  <div style={{ position: 'relative' }}>
                    <iframe
                      className='popup-image-preview img-fluid'
                      src={popupImgPreview}
                      height='100%'
                      width='100%'
                      style={{ border: '1px solid #ebebeb' }}
                    />
                  </div>
                ) : (
                  <div style={{ position: 'relative' }}>
                    <img
                      className='popup-image-preview img-fluid'
                      src={popupImgPreview}
                      height='100%'
                      width='100%'
                      style={{ border: '1px solid #ebebeb' }}
                    />
                  </div>
                )} */}
              </Col>
            </Row>
          </Container>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default React.memo(OtherOwners);
